/**
 * @typedef {import('../interfaces/context/IArchivosAdjuntos.context.interface').IArchivosAdjuntosContext} IArchivosAdjuntosContext
 * @typedef {import('../interfaces/models/IArchivoAdjunto.interface').IArchivoAdjunto} IArchivoAdjunto
 */

import React, { createContext, useContext, useState } from 'react';
import { node } from 'prop-types';
import LoadingMask from '../components/LoadingMask';

const contextDefaultValue = {
  isLoading: false,
  setIsLoading: null,
};

const LoadingContext = createContext(contextDefaultValue);

/**
 * Componente que genera el Layout
 *
 * @component
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const value = {
    isLoading,
    setIsLoading,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {isLoading && <LoadingMask />}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: node.isRequired,
};

const useLoading = () => {
  const context = useContext(LoadingContext);

  if (context === undefined) {
    throw new Error('useSession must be used within provider');
  }

  return context;
};

export { LoadingProvider, LoadingContext, useLoading };
